import React from 'react';

const NotFoundPage = () => (
  <div style={{
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#f8fafc',
    padding: 24,
    textAlign: 'center',
    gap: 16,
  }}>
    <div style={{
      width: 72, height: 72, borderRadius: '50%',
      background: '#ede9fe',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
    }}>
      <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#6366f1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="8" x2="12" y2="12" />
        <line x1="12" y1="16" x2="12.01" y2="16" />
      </svg>
    </div>
    <div>
      <h1 style={{ fontSize: 48, fontWeight: 900, color: '#6366f1', margin: '0 0 4px' }}>404</h1>
      <p style={{ fontSize: 16, fontWeight: 600, color: '#111827', margin: '0 0 8px' }}>Страница не найдена</p>
      <p style={{ fontSize: 14, color: '#6b7280', margin: 0 }}>
        Эта ссылка устарела или страница не существует.
      </p>
    </div>
  </div>
);

export default NotFoundPage;